import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ApiError, api, keys, type Uuid } from "@shared/api";
import { Dialog } from "@shared/ui/bits";
import { Button } from "@shared/ui/button";

/**
 * Выгнать с сервера — с вопросом, как в Discord: действие одно нажатие, а
 * вернуть человека можно только новым приглашением.
 */
export function KickDialog({
  serverId,
  user,
  onClose,
  onDone,
}: {
  serverId: Uuid;
  user: { id: Uuid; name: string };
  onClose: () => void;
  onDone?: () => void;
}) {
  const cache = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  async function kick() {
    setBusy(true);
    setProblem(null);
    try {
      await api.servers.kick(serverId, user.id);
      await cache.invalidateQueries({ queryKey: keys.members(serverId) });
      onDone?.();
      onClose();
    } catch (error) {
      setProblem(error instanceof ApiError ? error.message : "Не вышло выгнать");
      setBusy(false);
    }
  }

  return (
    <Dialog
      title={`Выгнать ${user.name}?`}
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" type="button" onClick={onClose}>
            Отмена
          </Button>
          <Button variant="destructive" type="button" disabled={busy} onClick={() => void kick()}>
            Выгнать
          </Button>
        </>
      }
    >
      <p className="small muted" style={{ margin: 0 }}>
        {user.name} уйдёт с сервера, но сможет вернуться по новому приглашению.
      </p>
      {problem && <p className="small danger-text" style={{ margin: 0 }}>{problem}</p>}
    </Dialog>
  );
}
